import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { restoreAuthFromStorage } from '../api/Client';
import '../styles/home.css';
import logo from '../assets/logo.png';
import { useAskLocalNotifOnFirstLaunch } from "../notifications/useAskLocalNotifOnFirstLaunch";

export default function HomePage() {
  const navigate = useNavigate();
  useAskLocalNotifOnFirstLaunch();

  useEffect(() => {
    (async () => {
      const { access, refresh, user } = await restoreAuthFromStorage();
      console.log("🔑 Restaurado:", { access, refresh, user });
      if (access) {
        navigate(user?.moveOnly ? '/move' : '/product', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <>
      <div className="top-bar" />
      <div className="home-page">
        <div className="home-card">
          <div className="logo">
            <img src={logo} alt="Human Perform" />
          </div>
          <Link to="/register" className="grad-btn">Registro</Link>
          <Link to="/login" className="grad-btn">Acceso</Link>
          <Link to="/login?next=move" className="grad-btn move-entry-btn">Human Move</Link>
          <Link to="/public-services" className="info-link">
            Ver servicios y productos disponibles
          </Link>
        </div>
      </div>
      <div className="bottom-bar" />
    </>
  );
}
